import React from 'react'
import { Button, Container, Image, Nav, Navbar } from 'react-bootstrap'
import { BsMoon, BsSun } from 'react-icons/bs'
import { useTheme } from '@config/theme.config'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@store/store'
import { Link, useLocation } from 'react-router-dom'
import { logout } from '@store/thunk/auth.thunk'

const HeaderComponent = () => {
  const { theme, toggleTheme } = useTheme()
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault()
    dispatch(logout())
  }

  const handleThemeChange = (e: any) => {
    e.preventDefault()
    toggleTheme()
  }

  const getLinkClasses = (path: string): string => {
    const defaultClasses = `mt-2 nav-link text-${theme === 'dark' ? 'light' : 'dark'} fw-bold rounded-top d-flex align-items-center px-5`
    const linkActiveClasses = defaultClasses + ' ' + 'bg-light-subtle'
    const linkPassiveClasses = defaultClasses + ' ' + 'bg-dark-subtle'
    return location.pathname == path ? linkActiveClasses : linkPassiveClasses
  }

  return (
    <Navbar bg={'dark'} variant={'dark'} className={'pb-0'} expand="md">
      <Container>
        <Navbar.Brand href="/" className="">
          <Image
            src={'/dark_mode_small.png'}
            width="150px"
            alt="Logo"
            className="pb-2"
          />
        </Navbar.Brand>
        <Nav className="ms-4 me-auto" style={{ height: '60px' }}>
          <Link to="/" className={getLinkClasses('/')}>
            Zprávy
          </Link>
          <Link to="/audio" className={getLinkClasses('/audio')}>
            Zvuky
          </Link>
          <Link to="/program" className={getLinkClasses('/program')}>
            Relace
          </Link>
          <Link to="/regions" className={getLinkClasses('/regions')}>
            Regiony
          </Link>
        </Nav>
        <Nav className="align-items-center flex-row ">
          <Button
            onClick={handleThemeChange}
            variant={'outline-light'}
            className="me-1"
          >
            {theme == 'dark' ? <BsSun /> : <BsMoon />}
          </Button>
          <Button onClick={(e) => handleLogout(e)} variant="danger">
            Odhlásit
          </Button>
        </Nav>
      </Container>
    </Navbar>
  )
}

export default HeaderComponent
